import { EventEmitter, Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class onlinestores{

     dataemitterr= new EventEmitter<any>();
 //   dataemitterr= new Subject<any>();

    raiseDataEmitterEvent(data:any){
        this.dataemitterr.next(data);

    }
}